"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promisedWait = void 0;
// DEPRECATED. Update to: src/promised-wait
var promised_wait_1 = require("../utils/promised-wait");
Object.defineProperty(exports, "promisedWait", { enumerable: true, get: function () { return promised_wait_1.promisedWait; } });
//# sourceMappingURL=promised-wait.js.map